import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { LineChartWithReferenceLine } from '../LineChartWithReferenceLine';
import {
  ScenarioDataPoint,
  ScenarioReferenceLine,
  ScenarioChartKey,
} from '../../../../helpers/Initiatives.types';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  graphData: ScenarioDataPoint[] | undefined;
  referenceLines: ScenarioReferenceLine[] | undefined;
  keys: ScenarioChartKey[] | undefined;
};

const ChartExpandModal = ({
  isOpen,
  onClose,
  graphData,
  referenceLines,
  keys,
}: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />

      <ModalContent>
        <ModalHeader mb={10}>Scope, Effort, and Projection</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box w="100%" h="60vh">
            <LineChartWithReferenceLine
              graphData={graphData}
              referenceLines={referenceLines}
              keys={keys}
            />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ChartExpandModal;
